import DividendBaseCriteria from './DividendBaseCriteria';

export default class IssuerDividendCriteria extends DividendBaseCriteria {

    constructor() {
        super();
        this.makeObservable();
    }
    
    // Client only properties / methods

    public toString(): string {
        return "Issuer Dividend Criteria";
    }
}